import 'react-responsive-modal/styles.css';
import { GANHE_MAIS_CORRETOR_CLIENT_URL } from '../../constants/ClientUrls';
import styles from './style.module.css';

import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { Input } from '../../components/forms/Input';
import { Loading } from '../../components/Loading';
import { Notify } from '../../components/Notify';
import { ButtonLogout } from './components/ButtonLogout';
import { ModalChangePassword } from './components/ModalChangePassword';
import { ModalConfirmDeletePlayer } from './components/ModalConfirmDeletePlayer';
import { ModalConfirmRegister } from './components/ModalConfirmRegister';
import { ModalTerms } from './components/ModalTerms';

import { ButtonBack } from '../../components/ButtonBack';
import { HelmetComponent } from '../../components/Helmet';
import { PlayerAvatar } from '../../components/PlayerAvatar';
import * as routes from '../../constants/Routes';
import { useAuth } from '../../hooks/useAuth';
import { api, getAPIURL } from '../../server/api';
import { maskTEL, MaskCPF, MaskCNPJ, normalizeCpfCnpj } from '../../utils/mask';
import { FormValues, ICity, IClientTerms, IStateList } from './interfaces';
import { stripAtPrefix } from '../../utils/stripAtPrefix';

import { Markup } from 'interweave';
import Skeleton from 'react-loading-skeleton';
import { LevelProfile } from './components/LevelProfile';
import { List, ListItem } from '../../components/List';
import { InputInternational } from '../../components/forms/InputInternational';
import { ModalConfirmRegisterPorteiro } from './components/ModalConfirmRegisterPorteiro';
import { toast } from 'react-toastify';
import { ModalFinishRegisterPorteiro } from './components/ModalFinishRegisterPorteiro';
import { ModalBonusPrimeiroAcesso } from './components/ModalBonusPrimeiroAcesso';
import { useIbge } from '../../hooks/useIbge';
import Modal from 'react-responsive-modal';
import Compressor from 'compressorjs';
import { Autocomplete, TextField } from '@mui/material';

const ADN_CLIENT_URL = 'adn';

interface IClientBroker {
  id: string;
  name: string;
}

const PRIVACY_POLICY_LEAD_URL =
  'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPOLI%CC%81TICA%20DE%20PRIVACIDADE%20LGPD%20COMPLIANCE%202026.pdf?alt=media&token=f6339049-9c75-4ac2-8417-a70c9d75be94';

const PRIVACY_POLICY_CORRETOR_URL =
  'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPoliticaPrivacidade_GanheMaisCorretor_CORRETOR.docx.pdf?alt=media&token=0d3cc869-b87e-4c60-b611-b4313265034d';

export function RegisterDetails({ editing }: any) {
  const { player, client, loadingAuth, getClientByAliasAndPlayer, signOut } =
    useAuth();
  const { getStates, getCities } = useIbge();
  const [activeRoute, setActiveRoute] = useState('');
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const [correctors, setCorrectors] = useState<Array<any>>();
  const [clientBrokers, setClientBrokers] = useState<IClientBroker[]>([]);
  const [loadingClientBrokers, setLoadingClientBrokers] =
    useState<boolean>(false);
  const [selectedBroker, setSelectedBroker] = useState<IClientBroker | null>(
    null
  );
  const [clientTerms, setClientTerms] = useState<IClientTerms>();
  const [state, setState] = useState<string>();
  const [stateList, setStateList] = useState<Array<IStateList>>();
  const [cityList, setCityList] = useState<Array<ICity>>();
  const [photoURL, setPhotoURL] = useState<string>();
  const [loadingInputs, setLoadingInputs] = useState<boolean>(false);
  const [formInvalid, setFormInvalid] = useState<boolean>(false);
  const [playerRegister, setPlayerRegister] = useState<any>();
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);
  const [acceptedPrivacyTerm, setAcceptedPrivacyTerm] =
    useState<boolean>(false);

  const [modalPasswordIsOpen, setModalPasswordIsOpen] =
    useState<boolean>(false);
  const [modalTermsIsOpen, setModalTermsIsOpen] = useState<boolean>(false);
  const [modalIsOpenConfirmRegister, setModalIsOpenConfirmRegister] =
    useState<boolean>(false);
  const [
    modalIsOpenConfirmRegisterPorteiro,
    setModalIsOpenConfirmRegisterPorteiro,
  ] = useState<boolean>(false);
  const [
    modalIsOpenFinishRegisterPorteiro,
    setModalIsOpenFinishRegisterPorteiro,
  ] = useState<boolean>(false);
  const [modalIsOpenConfirmDeletePlayer, setModalIsOpenConfirmDeletePlayer] =
    useState<boolean>(false);
  const [isLoadingRequestPlayer, setIsLoadingRequestPlayer] =
    useState<boolean>(true);
  const [isDisabledCpf, setIsDisabledCpf] = useState<boolean>(true);
  const [isBusinessPlayer, setIsBusinessPlayer] = useState<boolean>(false);
  const [isOpenModalEmailRecovery, setIsOpenModalEmailRecovery] =
    useState<boolean>(false);
  const [emailRecovery, setEmailRecovery] = useState('');

  const [isStep1Complete, setIsStep1Complete] = useState<boolean>(false);
  const [actionsList, setActionsList] = useState([]);
  const [modalBonusIsOpen, setModalBonusIsOpen] = useState<boolean>(false);
  const cpfAutoFixSent = useRef(false);

  useEffect(() => {
    const isBusinessLocal = localStorage.getItem('isBusiness');

    if (isBusinessLocal !== null && isBusinessLocal === 'true') {
      setIsBusinessPlayer(true);
    }

    const apiRequest = async () => {
      const parameters = {
        searchFunctionality: 'getSelfPlayerRegisterDetails',
        userType: 'player',
        playerId: player.id,
        clientId: client.id,
      };

      await api
        .post('/search', parameters)
        .then((res) => {
          setPlayerRegister(res.data.data.player);

          if (
            client &&
            client.mgmVinculated &&
            client.mgmVinculated === 'true' &&
            !client.isOpenRegisterButton &&
            res.data.data.player &&
            res.data.data.player.regional === 'nao'
          ) {
            setCorrectors(res.data.data.listCorretores);
          }
          setIsLoadingRequestPlayer(false);
        })
        .catch((e) => {
          console.log('getSelfPlayerRegisterDetails error: ', e);
        });
    };
    apiRequest();

    if (client && client.clientUrl === 'bomnegocio') {
      getActionsList();
    }
  }, []);

  const isAdnClient = editing && client?.clientUrl === ADN_CLIENT_URL;
  // Corretor já vinculado (ex.: veio por link de convite) não pode ser trocado
  const hasLockedHost = !!playerRegister?.hostId;
  const showAdnBrokerField =
    isAdnClient &&
    !!playerRegister &&
    watch('regional') === 'nao' &&
    (!hasLockedHost || !!selectedBroker);

  useEffect(() => {
    if (isAdnClient) {
      getClientBrokers();
    }
  }, [isAdnClient]);

  useEffect(() => {
    if (!hasLockedHost || clientBrokers.length === 0) return;
    const host = clientBrokers.find(
      (broker) => broker.id === playerRegister.hostId
    );
    setSelectedBroker(host || null);
  }, [hasLockedHost, clientBrokers]);

  useEffect(() => {
    setValue('acceptedTerms', getValues('acceptedTerms'));
  }, [acceptedTerms]);

  useEffect(() => {
    setValue('acceptedPrivacyTerm', getValues('acceptedPrivacyTerm'));
  }, [acceptedPrivacyTerm]);

  useEffect(() => {
    if (playerRegister) {
      const photoUrlDefault =
        player && playerRegister && playerRegister.photoURL
          ? playerRegister.photoURL
          : '';

      if (!playerRegister.acceptedTerms) {
        setModalIsOpenConfirmRegister(true);
        setModalIsOpenConfirmRegisterPorteiro(true);
        setIsDisabledCpf(false);
      }

      if (
        editing &&
        client.moduleCredits === true &&
        client.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL &&
        !playerRegister.acceptedTerms
      ) {
        setModalBonusIsOpen(true);
      }

      const normalizedCpf = normalizeCpfCnpj(playerRegister.cpf);

      if (
        !cpfAutoFixSent.current &&
        normalizedCpf &&
        normalizedCpf !== playerRegister.cpf
      ) {
        cpfAutoFixSent.current = true;
        api
          .post('/update', {
            playerData: {
              targetPublic: client.targetPublic,
              ...playerRegister,
              cpf: normalizedCpf,
              editing: editing ? true : false,
            },
            userType: 'player',
            updateFunctionality: 'updatePlayer',
          })
          .catch((error) => {
            console.log('cpf auto-fix error', error);
          });
      }

      setValue('name', playerRegister.name);
      setValue('email', playerRegister.email);
      setValue('cpf', normalizedCpf);
      setValue('phoneNumber', playerRegister.phoneNumber);
      setValue('state', playerRegister.state);
      setValue('city', playerRegister.city);
      setValue('acceptedTerms', playerRegister.acceptedTerms);
      setValue('regional', playerRegister.regional);
      setValue('photoURL', playerRegister.photoURL);
      setValue('birthDate', playerRegister.birthDate);
      setValue('role', playerRegister.role);
      setValue('businessName', playerRegister.businessName);

      setValue('patrimonyBedrooms', playerRegister.patrimonyBedrooms);
      setValue('patrimonyNumber', playerRegister.patrimonyNumber);
      setValue('patrimonyCep', playerRegister.patrimonyCep);
      setValue('patrimonyRecreation', playerRegister.patrimonyRecreation);
      setValue(
        'patrimonyTimeConstruction',
        playerRegister.patrimonyTimeConstruction
      );
      setValue('patrimonySize', playerRegister.patrimonySize);
      setValue(
        'socialMedia.instagram',
        playerRegister.socialMedia?.instagram || ''
      );
      setValue(
        'socialMedia.facebook',
        playerRegister.socialMedia?.facebook || ''
      );
      setValue('socialMedia.tiktok', playerRegister.socialMedia?.tiktok || '');
      setValue(
        'socialMedia.youtube',
        playerRegister.socialMedia?.youtube || ''
      );
      setPhotoURL(photoUrlDefault);
      setState(playerRegister.state);

      if (playerRegister.regional === 'sim') {
        setValue(
          'acceptedPrivacyTerm',
          playerRegister.acceptedPrivacyTerm || false
        );
        setAcceptedPrivacyTerm(playerRegister.acceptedPrivacyTerm || false);
      }
    }

    if (client && client.clientUrl === 'indiqueeganhe') {
      getBrokersRelational(); //nova função para trazer os corretores ativos.
    }
    if (client && client.clientUrl === 'bild') {
      if (getValues('regional') !== 'VITTA - Franca') {
        getBrokersBild();
      }
    }
  }, [playerRegister]);

  useEffect(() => {
    const nenhumCorrector = correctors && correctors[0];
    let correctorSet = JSON.stringify(nenhumCorrector);
    if (client && client.clientUrl === 'bild') {
      if (playerRegister && playerRegister.corretor) {
        correctorSet = JSON.stringify(playerRegister.corretor);
        return setValue('corretor', correctorSet);
      }
    }
    if (client && client.clientUrl === 'indiqueeganhe') {
      if (playerRegister && playerRegister.corrector) {
        const findCorretor = correctors?.find(
          (corretor) => corretor.value === playerRegister.corrector.value
        );
        if (findCorretor) {
          correctorSet = JSON.stringify(findCorretor);
        } else {
          correctorSet = JSON.stringify(correctors && correctors[0]);
        }
      }
    }
    if (
      client &&
      client.mgmVinculated &&
      client.mgmVinculated === 'true' &&
      !client.isOpenRegisterButton &&
      playerRegister &&
      playerRegister.regional === 'nao'
    ) {
      if (playerRegister && playerRegister.playerHost) {
        const playerHost = {
          label: `${playerRegister.playerHost.name} - ${playerRegister.playerHost.email}`,
          value: playerRegister.playerHost.id,
        };
        correctorSet = JSON.stringify(playerHost);
        setValue('hostId', playerRegister.playerHost.id);
      }
    }

    setValue('corrector', correctorSet);
  }, [correctors]);

  useEffect(() => {
    if (state) {
      getCityList(state);
    }
  }, [state]);

  useEffect(() => {
    const splitPathName = location.pathname.split('/');
    const pathName = splitPathName[1];

    setActiveRoute(pathName);
  }, [location.pathname]);

  useEffect(() => {
    const getRenderFuntionsInitials = async () => {
      await getClientTerms();
      await getStateList();
    };
    getRenderFuntionsInitials();
  }, []);

  useEffect(() => {
    if (playerRegister) {
      if (
        (clientTerms?.lastUpdate &&
          !playerRegister.updateTermsAccepted &&
          playerRegister.createdAt &&
          playerRegister.createdAt < clientTerms?.lastUpdate) ||
        (playerRegister &&
          playerRegister.updateTermsAccepted &&
          clientTerms?.lastUpdate &&
          playerRegister.updateTermsAccepted < clientTerms?.lastUpdate)
      ) {
        setValue('acceptedTerms', false);
      }
    }
  }, [playerRegister]);

  const toggleModalDeletePlayer = () => {
    setModalIsOpenConfirmDeletePlayer(!modalIsOpenConfirmDeletePlayer);
  };

  const Porteiro = () => {
    setModalIsOpenConfirmRegister(!modalIsOpenConfirmRegister);
  };

  const toggleModalConfirmRegisterPorteiro = () => {
    setModalIsOpenConfirmRegisterPorteiro(!modalIsOpenConfirmRegisterPorteiro);
  };

  const toggleModalFinishRegisterPorteiro = () => {
    setModalIsOpenFinishRegisterPorteiro(!modalIsOpenFinishRegisterPorteiro);
  };

  const getActionsList = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getClientActions',
        userType: 'player',
        clientId: client?.id,
        playerId: player?.id,
      };

      const { data } = await api.post(`/search`, parameters);

      if (data.data && data.data.actions) {
        setActionsList(data.data.actions);
      }
    } catch (error) {
      console.log('error getActionsList-->', error);
    }
  };

  async function deleteAccount() {
    const parameters = {
      userType: 'administrator',
      searchFunctionality: 'deletePlayer',
      clientId: client?.id,
      playerId: playerRegister?.id,
    };

    await api.post('/search', parameters);
    signOut();
    sessionStorage.clear();
    navigate(`/_/${client.clientUrl}`);
  }

  const getBrokersBild = async () => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'getBrokersBild',
      };

      await api
        .post('/search', parameters)
        .then((response) => {
          setCorrectors(response.data.data);
        })
        .catch((e) => console.log('getBrokersBild erroooo', e));
    } catch (error) {
      console.log('getBrokersBild error:', error);
    }
  };

  const getClientBrokers = async () => {
    setLoadingClientBrokers(true);
    try {
      const response = await api.post('/search', {
        userType: 'player',
        searchFunctionality: 'getClientBrokers',
        clientId: client.id,
      });
      const brokers: IClientBroker[] = response.data?.data || [];
      setClientBrokers(brokers.filter((broker) => broker.id !== player?.id));
    } catch (error) {
      console.log('getClientBrokers error:', error);
    } finally {
      setLoadingClientBrokers(false);
    }
  };

  const getBrokersRelational = async () => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'getBrokersRelationalEndpoint',
        clientId: client.id,
      };

      await api
        .post(`/search`, parameters)
        .then((response) => {
          setCorrectors(response.data.data);
        })
        .catch((e) => console.log('getBrokersRelationalEndpoint errorr: ', e));
    } catch (error) {
      console.log('getBrokersRelationalEndpoint error:', error);
    }
  };

  const getClientTerms = async () => {
    const parameters = {
      searchFunctionality: 'getClientTerms',
      userType: 'player',
      clientId: client && client.id,
    };

    await api
      .post(`/search`, parameters)
      .then((res) => {
        const result = res.data.data;
        if (result) {
          setClientTerms(result);
          if (
            (result?.lastUpdate &&
              !player.updateTermsAccepted &&
              player.createdAt &&
              player.createdAt < result?.lastUpdate) ||
            (player &&
              player.updateTermsAccepted &&
              result?.lastUpdate &&
              player.updateTermsAccepted < result?.lastUpdate)
          ) {
            Notify('O cliente atualizou os termos de uso.', 'warn');
          }
        }
      })
      .catch((error) => {
        console.log('getClientTerms error: ', error);
      });
  };

  const getStateList = async () => {
    const states = await getStates();
    setStateList(states);
  };

  const getCityList = async (state: string) => {
    const cities = await getCities(state);
    setCityList(cities);
  };

  const handleForm = handleSubmit(async (formData: FormValues) => {
    try {
      if (
        client &&
        client.isActiveRegisterPhoneNumber &&
        client.isActiveRegisterPhoneNumber === 'true'
      ) {
        if (formData.phoneNumber && formData.phoneNumber.length < 14) {
          return Notify('Número de telefone incompleto', 'error');
        }
      }
      if (formInvalid) {
        return Notify('Formato de telefone incorretot', 'warn');
      }

      if (
        client &&
        client.clientUrl === 'bild'
        // || (client && client.clientUrl === 'ganhemais')
      ) {
        if (formData.corretor) {
          const dataCorretor = JSON.parse(formData.corretor);

          formData.corretor = dataCorretor;
          formData.corrector = null;
        }
      }
      if (client && client.clientUrl === 'indiqueeganhe') {
        if (formData.corrector) {
          const dataCorretor = JSON.parse(formData.corrector);

          formData.corrector = dataCorretor;
          formData.corretor = null;
        }
      }
      if (isAdnClient) {
        if (hasLockedHost) {
          formData.hostId = playerRegister.hostId;
        } else if (formData.regional === 'nao' && selectedBroker) {
          formData.hostId = selectedBroker.id;
        } else {
          delete formData.hostId;
        }
      }

      // if (
      //   client &&
      //   client.mgmVinculated &&
      //   client.mgmVinculated === 'true' &&
      //   !client.isOpenRegisterButton &&
      //   playerRegister &&
      //   playerRegister.regional === 'nao'
      // ) {
      //   const dataCorretor = JSON.parse(formData.corrector);

      //   formData.corrector = null;
      //   formData.hostId = dataCorretor.value ? dataCorretor.value : null;
      //   setIsEmptyCorretor(false);
      // }

      const parameters: any = {
        playerData: {
          targetPublic: client.targetPublic,
          ...playerRegister,
          ...formData,
        },
        userType: 'player',
        updateFunctionality: 'updatePlayer',
      };

      parameters.playerData['editing'] = editing ? true : false;

      if (isBusinessPlayer) {
        parameters.playerData.businessName = formData.businessName;
      }

      if (!parameters.playerData.regional) {
        parameters.playerData.regional = 'nao';
      }

      const response = await api.post(`/update`, parameters);
      const data = response.data;

      const messageData = data.message.text || data.message;
      const messageDataEmail = data.message.email;

      if (data.success) {
        Notify(data.message, 'success');
        await getClientByAliasAndPlayer();
        if (client && client.clientUrl === 'bomnegocio' && !editing) {
          setModalIsOpenFinishRegisterPorteiro(true);
        } else {
          navigate(routes.HOME);
        }
      } else {
        Notify(messageData, 'error');
        if (messageDataEmail) {
          setIsOpenModalEmailRecovery(!isOpenModalEmailRecovery);
          setValue('cpf', ''); // limpando CPF
          setEmailRecovery(messageDataEmail);
        }
      }

      localStorage.removeItem('isBusiness');
    } catch (error) {
      console.log('handleForm error', error);
    }
  });

  const handleCompressedUpload = async (file: any) => {
    return new Promise((resolve, reject) => {
      try {
        const { name } = file;
        const randomizeName =
          Math.random()
            .toString(36)
            .replace(/[^a-z]+/g, '') +
          '.' +
          name.split('.');
        const compress = new DataTransfer();
        new Compressor(file, {
          quality: 0.15,
          mimeType: 'image/jpeg',
          success: (result) => {
            compress.items.add(
              new File([result], randomizeName, { type: result.type })
            );
            resolve(compress.files[0]);
          },
        });
      } catch (error) {
        reject();
      }
    });
  };

  const handleUploadSuccessImage = async (file: any) => {
    const fileFormData = new FormData();
    fileFormData.append('userType', 'player');
    fileFormData.append('uploadFunctionality', 'uploadImage');
    fileFormData.append('ref', 'playerProfile');
    fileFormData.append('file', file);

    const requestOptions = {
      method: 'POST',
      body: fileFormData,
    };

    const response = await fetch(`${getAPIURL()}/upload`, requestOptions);
    const data = await response.json();

    setPhotoURL(data.data);
    setLoadingInputs(false);
    setValue('photoURL', data.data);
  };

  const handleSubmitPhoto = async (e: any) => {
    setLoadingInputs(true);

    const compressedFile = await handleCompressedUpload(e.target.files[0]);

    await handleUploadSuccessImage(compressedFile);
  };

  const toggleModalPassword = () => {
    setModalPasswordIsOpen(!modalPasswordIsOpen);
  };

  const toggleModalTerms = () => {
    setModalTermsIsOpen(!modalTermsIsOpen);
  };

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;
    if (name === 'state') {
      setState(value);
      setValue('state', value);
    }
  };

  const handleUploadImage = () => {
    const input: any = document.querySelector('#uploadImage');
    if (input) {
      input.click();
    }
  };

  if (loadingAuth) {
    return <Loading />;
  }

  const addPointsToPlayer = async (points: number) => {
    const params = {
      playerId: playerRegister.id,
      clientId: client.id,
      actionId: actionsList.length > 0 ? actionsList[0].id : '',
      points: points,
      extraPoints: true,
      isSecondaryRule: 'false',
      secondaryRule: 0,
      authUser: client.id,
    };

    const endPoint = `/conversions`;

    await api
      .post(endPoint, params)
      .then(() => {
        location.reload();
      })
      .catch((error) => {
        toast.error(
          `Ops! Não foi possível adicionar os ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}. Contate o suporte!`
        );
        console.log('conversions error: ', error);
      });
  };

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Detalhes do cadastro'}
      />
      <div className="container">
        <div className="my-3">
          <div className="d-flex justify-content-between">
            {activeRoute === 'editProfile' ? (
              <ButtonBack title="Editar perfil" />
            ) : (
              <ButtonLogout />
            )}

            <Button
              icon="delete"
              color="danger"
              text="Excluir conta"
              onClick={toggleModalDeletePlayer}
            />
          </div>
        </div>

        {/* Skeleton do Perfil e ações */}
        {isLoadingRequestPlayer && (
          <>
            <div className="d-flex flex-column align-items-center">
              <Skeleton height={100} width={100} circle={true} />
              <div className="d-flex gap-3 my-3">
                <Skeleton height={30} width={100} />
                <Skeleton height={30} width={100} />
              </div>
            </div>
            <div className="my-3">
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <div className="my-3">
                    <Skeleton height={40} />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div className="my-3">
                    <Skeleton height={40} />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div className="my-3">
                    <Skeleton height={40} />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div className="my-3">
                    <Skeleton height={40} />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div className="my-3">
                    <Skeleton height={40} />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div className="my-3">
                    <Skeleton height={40} />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div className="my-3"></div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <hr />
                  <div className="my-3">
                    <Skeleton height={40} />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* fim Skeleton do Perfil e ações */}

        {/* formulário do perfil */}
        {!isLoadingRequestPlayer &&
          client &&
          client.clientUrl !== 'bomnegocio' && (
            <div className="row">
              <div className="col-sm-12 col-md-3">
                <div className="mb-3">
                  <Card>
                    <LevelProfile
                      photo={photoURL}
                      name={playerRegister.name}
                      email={playerRegister.email}
                      cpf={playerRegister.cpf}
                      phoneNumber={playerRegister.phoneNumber}
                    />
                  </Card>
                </div>
              </div>
              <div className="col-sm-12 col-md-9">
                <div className="container">
                  {/* Perfil e ações do perfil */}
                  {!isLoadingRequestPlayer && (
                    <div className="d-flex flex-column align-items-center">
                      <PlayerAvatar
                        photoURL={photoURL || undefined}
                        size={100}
                      />
                      <div className="d-flex gap-3 my-3">
                        <Button
                          text="Alterar foto"
                          icon="image_search"
                          onClick={handleUploadImage}
                          disabled={loadingInputs}
                          color="primary"
                        />
                        <Button
                          text="Alterar senha"
                          icon="password"
                          disabled={loadingInputs}
                          onClick={toggleModalPassword}
                          color="flat"
                        />
                      </div>
                      <Input
                        hidden
                        type="file"
                        id="uploadImage"
                        {...register('photoURL', {
                          required: false,
                          onChange: (e) => handleSubmitPhoto(e),
                        })}
                        aria-invalid={errors.photoURL ? 'true' : 'false'}
                      />
                    </div>
                  )}
                  {/* fim Perfil e ações do perfil */}
                  <form onSubmit={handleForm}>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6 mb-4">
                        <label htmlFor="name">Nome</label>
                        <Input
                          type="text"
                          placeholder="Nome"
                          errors={
                            errors.name ? 'Campo de nome obrigatório' : ''
                          }
                          {...register('name', {
                            required: true,
                            // onChange: (e) => {
                            //   const changedPlayer = {
                            //     ...playerRegister,
                            //     name: e.target.value,
                            //   };
                            //   setPlayerRegister(changedPlayer);
                            // },
                          })}
                          aria-invalid={errors.name ? 'true' : 'false'}
                        />
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 mb-4">
                        <label htmlFor="email">E-mail de acesso</label>
                        <Input
                          type="text"
                          placeholder="E-mail de acesso"
                          disabled
                          readOnly
                          errors={
                            errors.email ? 'Campo de email obrigatório' : ''
                          }
                          {...register('email', {
                            required: true,
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                              message: 'invalid email address',
                            },
                          })}
                          aria-invalid={errors.email ? 'true' : 'false'}
                        />
                      </div>

                      {client &&
                        client.clientUrl !== 'credcrea' &&
                        client.isActiveRegisterPhoneNumber &&
                        client.isActiveRegisterPhoneNumber === 'true' && (
                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="phoneNumber">Telefone</label>
                            {client && client.clientUrl !== 'emr' && (
                              <Input
                                prefix="+55"
                                maxLength={15}
                                type="text"
                                placeholder="Telefone"
                                errors={
                                  errors.phoneNumber
                                    ? 'Campo de telefone obrigatório'
                                    : ''
                                }
                                {...register('phoneNumber', {
                                  required: true,
                                  onChange: (event) => {
                                    const { value } = event.target;
                                    setValue('phoneNumber', maskTEL(value));
                                    const verifyLengthValue = value.replace(
                                      /\D/g,
                                      ''
                                    );

                                    if (verifyLengthValue.length > 11) {
                                      setFormInvalid(true);
                                      return Notify(
                                        'Formato de telefone incorreto',
                                        'warn'
                                      );
                                    } else {
                                      setFormInvalid(false);
                                    }
                                  },
                                })}
                                aria-invalid={
                                  errors.phoneNumber ? 'true' : 'false'
                                }
                              />
                            )}
                            {client && client.clientUrl === 'emr' && (
                              <InputInternational
                                register={register('phoneNumber', {
                                  required: true,
                                  onChange: (event) => {
                                    const { value } = event.target;
                                    setValue('phoneNumber', value);
                                    // Validar formato do telefone internacional
                                    const phoneRegex = /^\+[1-9]\d{1,13}$/;
                                    const isValidPhone = phoneRegex.test(value);
                                    if (value && !isValidPhone) {
                                      setFormInvalid(true);
                                      Notify(
                                        'Formato de telefone incorreto',
                                        'warn'
                                      );
                                    } else {
                                      setFormInvalid(false);
                                    }
                                  },
                                })}
                                errors={errors}
                                value={getValues('phoneNumber')}
                              />
                            )}
                          </div>
                        )}

                      <div className="col-12 col-sm-12 col-md-6 mb-4">
                        <label htmlFor="cpf">
                          {client &&
                          client.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL
                            ? 'CNPJ'
                            : 'CPF ou CNPJ'}
                        </label>
                        <Input
                          type="text"
                          placeholder={
                            client &&
                            client.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL
                              ? 'CNPJ'
                              : 'CPF ou CNPJ'
                          }
                          minLength={11}
                          disabled={isDisabledCpf}
                          errors={
                            errors.cpf
                              ? client &&
                                client.clientUrl ===
                                  GANHE_MAIS_CORRETOR_CLIENT_URL
                                ? 'Campo de cnpj obrigatório'
                                : 'Campo de cpf ou cnpj obrigatório'
                              : ''
                          }
                          {...register('cpf', {
                            required: true,
                            onChange: (event) => {
                              const { value } = event.target;
                              let maskedValue;
                              if (
                                client &&
                                client.clientUrl ===
                                  GANHE_MAIS_CORRETOR_CLIENT_URL
                              ) {
                                maskedValue = MaskCNPJ(value);
                              } else if (value.length <= 14) {
                                maskedValue = MaskCPF(value);
                              } else {
                                maskedValue = MaskCNPJ(value);
                              }
                              setValue('cpf', maskedValue);
                              setFormInvalid(false);
                            },
                          })}
                          aria-invalid={errors.cpf ? 'true' : 'false'}
                        />
                      </div>

                      {isBusinessPlayer && (
                        <div className="col-12 col-sm-12 col-md-6 mb-4">
                          <label htmlFor="cpf">Digite o nome do corretor</label>
                          <Input
                            type="text"
                            value={watch('businessName')}
                            placeholder="Digite o nome do corretor"
                            errors={
                              errors.businessName
                                ? 'Campo de cpf ou cnpj obrigatório'
                                : ''
                            }
                            {...register('businessName')}
                          />
                        </div>
                      )}

                      {client &&
                        client.clientUrl !== 'credcrea' &&
                        client.clientUrl !== 'emccampdemo' &&
                        client.clientUrl !== 'ganhemais' &&
                        client.isActiveRegisterBirthDate &&
                        client.isActiveRegisterBirthDate === 'true' && (
                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="birthDate">
                              Data de nascimento
                            </label>
                            <Input
                              type="date"
                              placeholder="Data de nascimento"
                              disabled={loadingInputs}
                              errors={
                                errors.phoneNumber
                                  ? 'Campo de data de nascimento obrigatório'
                                  : ''
                              }
                              {...register('birthDate', {
                                required: [
                                  'credcrea',
                                  'emccampdemo',
                                  'ganhemais',
                                ].includes(client.clientUrl)
                                  ? false
                                  : true,
                              })}
                              aria-invalid={
                                errors.phoneNumber ? 'true' : 'false'
                              }
                            />
                          </div>
                        )}

                      {client &&
                        client.secondarySegmentationChoice &&
                        client.secondarySegmentationChoice === 'true' && (
                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="role">
                              {client && client.nameSecondarySegmentation}
                            </label>
                            <select
                              className={`${styles.select}`}
                              disabled={loadingInputs}
                              {...register('role', {
                                required: true,
                              })}
                              aria-invalid={errors.role ? 'true' : 'false'}
                            >
                              <option value={''}>Selecione uma opção</option>
                              {client.secondarySegmentation &&
                                client.secondarySegmentation.map(
                                  (value: any, index: number) => (
                                    <option key={index} value={value.id}>
                                      {value.text}
                                    </option>
                                  )
                                )}
                            </select>
                            <span className={styles.error}>
                              {errors.role
                                ? `Campo de ${
                                    client && client.nameSecondarySegmentation
                                  } obrigatório'`
                                : ''}
                            </span>
                          </div>
                        )}

                      {client &&
                        client.clientUrl !== 'prideopen' &&
                        client.isActiveRegisterStateAndCity &&
                        client.isActiveRegisterStateAndCity === 'true' && (
                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="state">Estado de residência</label>
                            <select
                              className={`${styles.select}`}
                              disabled={loadingInputs}
                              {...register('state', {
                                required: true,
                                onChange: handleChange,
                              })}
                              aria-invalid={errors.state ? 'true' : 'false'}
                              value={getValues('state')}
                            >
                              <option value={''}>Selecione um estado</option>
                              {stateList &&
                                stateList.map((value) => (
                                  <option key={value.sigla} value={value.sigla}>
                                    {value.sigla}
                                  </option>
                                ))}
                            </select>
                            <span className={styles.error}>
                              {errors.state
                                ? 'Campo de estado de residência obrigatório'
                                : ''}
                            </span>
                          </div>
                        )}

                      {client &&
                        client.clientUrl !== 'prideopen' &&
                        client.isActiveRegisterStateAndCity &&
                        client.isActiveRegisterStateAndCity === 'true' && (
                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="city">Cidade de residência</label>
                            <select
                              className={`${styles.select}`}
                              disabled={loadingInputs}
                              {...register('city', {
                                required: true,
                              })}
                              aria-invalid={errors.city ? 'true' : 'false'}
                              value={watch('city')}
                            >
                              <option value={''}>Selecione uma cidade</option>
                              {cityList &&
                                cityList.map((value: any) => (
                                  <option key={value.nome} value={value.nome}>
                                    {value.nome}
                                  </option>
                                ))}
                            </select>
                            <span className={styles.error}>
                              {errors.city
                                ? 'Campo de cidade de residência obrigatória'
                                : ''}
                            </span>
                          </div>
                        )}

                      {/* Seleção da própria regional, configurada no
                          oqadminmaster (Editar cliente): "Deseja segmentar os
                          usuários?" = Sim e "Deseja que o Usuário selecione sua
                          regional?" = Sim. Só enquanto o cadastro não foi
                          completado (acceptedTerms); depois disso a regional
                          não pode mais ser trocada pelo player. */}
                      {playerRegister &&
                        !playerRegister.acceptedTerms &&
                        client?.segmentationChoice === 'true' &&
                        client?.isActiveRegisterRegional === true && (
                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="regional">
                              {client.scopeFieldName || 'Regional'}
                            </label>
                            <select
                              className={`${styles.select}`}
                              disabled={loadingInputs}
                              {...register('regional', {
                                required: true,
                              })}
                              aria-invalid={errors.regional ? 'true' : 'false'}
                            >
                              <option value={''}>Selecione uma opção</option>
                              <option value="sim">Sim</option>
                              <option value="nao">Não</option>
                            </select>
                            <span className={styles.error}>
                              {errors.regional
                                ? `Campo de ${
                                    client.scopeFieldName || 'Regional'
                                  } obrigatório`
                                : ''}
                            </span>
                          </div>
                        )}

                      {client?.settings?.postValidator?.enabled && (
                        <>
                          <div className="col-12 mb-2">
                            <label>Redes sociais</label>
                            <p
                              style={{
                                fontSize: 13,
                                opacity: 0.75,
                                marginBottom: 0,
                              }}
                            >
                              Cadastre o @ das suas redes sociais para poder
                              enviar prints no Validador de posts. Só é possível
                              enviar prints das redes com o @ preenchido.
                            </p>
                          </div>

                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="socialMedia.instagram">
                              Instagram
                            </label>
                            <Input
                              type="text"
                              prefix="@"
                              placeholder="seu.usuario"
                              {...register('socialMedia.instagram', {
                                onChange: (event) => {
                                  setValue(
                                    'socialMedia.instagram',
                                    stripAtPrefix(event.target.value)
                                  );
                                },
                              })}
                            />
                          </div>

                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="socialMedia.facebook">
                              Facebook
                            </label>
                            <Input
                              type="text"
                              prefix="@"
                              placeholder="seu.usuario"
                              {...register('socialMedia.facebook', {
                                onChange: (event) => {
                                  setValue(
                                    'socialMedia.facebook',
                                    stripAtPrefix(event.target.value)
                                  );
                                },
                              })}
                            />
                          </div>

                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="socialMedia.tiktok">TikTok</label>
                            <Input
                              type="text"
                              prefix="@"
                              placeholder="seu.usuario"
                              {...register('socialMedia.tiktok', {
                                onChange: (event) => {
                                  setValue(
                                    'socialMedia.tiktok',
                                    stripAtPrefix(event.target.value)
                                  );
                                },
                              })}
                            />
                          </div>

                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="socialMedia.youtube">YouTube</label>
                            <Input
                              type="text"
                              prefix="@"
                              placeholder="seu.usuario"
                              {...register('socialMedia.youtube', {
                                onChange: (event) => {
                                  setValue(
                                    'socialMedia.youtube',
                                    stripAtPrefix(event.target.value)
                                  );
                                },
                              })}
                            />
                          </div>
                        </>
                      )}
                    </div>

                    {/* {client && client.clientUrl === 'indiqueeganhe' && (
                      <div className="col-12 col-sm-12 col-md-6 mb-4">
                        <label htmlFor="correctors">
                          Qual corretor irá receber sua indicação?
                        </label>
                        <select
                          className={`${styles.select}`}
                          disabled={loadingInputs}
                          {...register('corrector', {
                            required: true,
                            // value={playerRegister.corrector}
                          })}
                          aria-invalid={errors.corrector ? 'true' : 'false'}
                        >
                          {correctors &&
                            correctors.length > 0 &&
                            correctors.map((value, index) => (
                              <option key={index} value={JSON.stringify(value)}>
                                {value.label}
                              </option>
                            ))}
                        </select>
                        <span className={styles.error}>
                          {errors.corrector
                            ? 'Campo de corretor obrigatório'
                            : ''}
                        </span>
                      </div>
                    )} */}

                    {showAdnBrokerField && (
                      <div className="col-12 col-sm-12 col-md-6 mb-4">
                        <label htmlFor="adnBroker">
                          Quer indicar um corretor?
                        </label>
                        <Autocomplete
                          id="adnBroker"
                          options={clientBrokers}
                          value={selectedBroker}
                          onChange={(_, broker) => setSelectedBroker(broker)}
                          getOptionLabel={(broker) => broker.name || ''}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          loading={loadingClientBrokers}
                          disabled={loadingInputs || hasLockedHost}
                          noOptionsText="Nenhum corretor encontrado"
                          loadingText="Carregando corretores..."
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              placeholder="Digite o nome do corretor (opcional)"
                              sx={{
                                backgroundColor: 'var(--background-input)',
                                borderRadius: '5px',
                                '& .MuiInputBase-input': {
                                  color: 'var(--color-text)',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                  border: 'none',
                                },
                              }}
                            />
                          )}
                        />
                      </div>
                    )}

                    {client && client.clientUrl === 'bild' && (
                      <div className="col-12 col-sm-12 col-md-6 mb-4">
                        <label htmlFor="correctors">
                          Se você foi indicado por algum(a) corretor(a),
                          selecione quem foi
                        </label>
                        <select
                          className={`${styles.select}`}
                          disabled={loadingInputs}
                          {...register('corretor', {
                            required: true,
                          })}
                          aria-invalid={errors.corretor ? 'true' : 'false'}
                        >
                          {correctors &&
                            correctors.map((value, index) => (
                              <option key={index} value={JSON.stringify(value)}>
                                {value.label}
                              </option>
                            ))}
                        </select>
                        <span className={styles.error}>
                          {errors.corretor
                            ? 'Campo de corretor obrigatório'
                            : ''}
                        </span>
                      </div>
                    )}

                    {/* {client && client.clientUrl === 'ganhemais' && (
                      <div className="col-12 col-sm-12 col-md-6 mb-4">
                        <label htmlFor="correctors">
                          Quer ser atendido por qual corretor?
                        </label>
                        <select
                          className={`${styles.select}`}
                          disabled={loadingInputs}
                          {...register('corretor', {
                            required: true,
                          })}
                          aria-invalid={errors.corretor ? 'true' : 'false'}
                        >
                          {correctors &&
                            correctors.map((value, index) => (
                              <option key={index} value={JSON.stringify(value)}>
                                {value.label}
                              </option>
                            ))}
                        </select>
                        <span className={styles.error}>
                          {errors.corretor
                            ? 'Campo de corretor obrigatório'
                            : ''}
                        </span>
                      </div>
                    )} */}

                    {/* {client &&
                      client.mgmVinculated &&
                      client.mgmVinculated === 'true' &&
                      client.clientUrl !== 'rivello' &&
                      !client.isOpenRegisterButton &&
                      playerRegister &&
                      playerRegister.regional === 'nao' &&
                      !playerRegister.hostId && (
                        <div className="col-12 col-sm-12 col-md-6 mb-4">
                          <label htmlFor="correctors">Corretor</label>
                          <select
                            className={`${styles.select}`}
                            disabled={loadingInputs || !isEmptyCorretor}
                            {...register('corrector', {
                              required: isEmptyCorretor ? true : false,
                            })}
                            aria-invalid={errors.corrector ? 'true' : 'false'}
                          >
                            {correctors &&
                              correctors.map((value, index) => (
                                <option
                                  key={index}
                                  value={JSON.stringify(value)}
                                >
                                  {value.label}
                                </option>
                              ))}
                          </select>
                          <span className={styles.error}>
                            {errors.corrector
                              ? 'Campo de corretor obrigatório'
                              : ''}
                          </span>
                          {isEmptyCorretor && (
                            <span className={styles.error}>
                              Campo de corretor obrigatório
                            </span>
                          )}
                        </div>
                      )} */}

                    <div className="mb-3">
                      <List>
                        <ListItem
                          content=""
                          secondaryContent="Por que o CPF/CNPJ?"
                          expansible={true}
                          classStyle="border-0 p-0"
                          contentExpansible={
                            <>
                              <div className="col-sm-12">
                                <div
                                  className="alert alert-success"
                                  role="alert"
                                >
                                  <p className="fw-semibold">
                                    Por que o CPF/CNPJ?
                                  </p>
                                  <p>
                                    A fim de garantir a segurança e
                                    autenticidade da sua conta, precisamos
                                    solicitar o seu CPF/CNPJ. Essas informações
                                    são essenciais para validações exclusivas e
                                    verídicas dos usuários da nossa plataforma.
                                  </p>
                                </div>
                              </div>
                              <div className="col-sm-12">
                                <div
                                  className="alert alert-warning mb-0"
                                  role="alert"
                                >
                                  <p className="fw-semibold">
                                    Proteção de dados
                                  </p>
                                  <p>
                                    Nunca, em hipótese alguma,
                                    compartilhamos/vendemos seus dados com
                                    terceiros.
                                  </p>
                                </div>
                              </div>
                            </>
                          }
                        />
                      </List>
                    </div>

                    {/* {!editing && (
                      <div className="col-sm-12">
                        <div className="alert alert-success" role="alert">
                          <p className="fw-semibold">Por que o CPF/CNPJ?</p>
                          <p>
                            A fim de garantir a segurança e autenticidade da sua
                            conta, precisamos solicitar o seu CPF/CNPJ. Essas
                            informações são essenciais para validações
                            exclusivas e verídicas dos usuários da nossa
                            plataforma.
                          </p>
                        </div>
                      </div>
                    )}

                    {!editing && (
                      <div className="col-sm-12">
                        <div className="alert alert-warning" role="alert">
                          <p className="fw-semibold">Proteção de dados</p>
                          <p>
                            Nunca, em hipótese alguma, compartilhamos/vendemos
                            seus dados com terceiros.
                          </p>
                        </div>
                      </div>
                    )} */}

                    <div className="col-sm-12">
                      <div className="d-flex flex-row-reverse me-check">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexCheckDefault"
                            {...register('acceptedTerms', {
                              required: true,
                            })}
                            disabled={loadingInputs}
                            onClick={() => {
                              setAcceptedTerms(!acceptedTerms);
                            }}
                            checked={getValues('acceptedTerms')}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault"
                          >
                            <Markup
                              content={`De acordo com as Leis 12.965/2014 e 13.709/2018, que regulam o uso da Internet e o tratamento de dados pessoais no Brasil, ao me inscrever autorizo ${
                                client?.companyName
                                  ? client?.companyName
                                  : 'OQ DIgital'
                              } a enviar notificações por e-mail ou outros meios e concordo com sua <a class="fw-bold"  target="_blank"
                          href="${client?.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL && playerRegister?.regional === 'sim' ? PRIVACY_POLICY_CORRETOR_URL : PRIVACY_POLICY_LEAD_URL}">Política de Privacidade</a> e <a class="fw-bold" href="/infos">Termos de uso</a>.`}
                            />
                          </label>
                        </div>
                      </div>
                    </div>

                    {playerRegister && playerRegister.regional === 'sim' && (
                      <div className="col-sm-12">
                        <div className="d-flex flex-row-reverse me-check">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexCheckPrivacyTerm"
                              {...register('acceptedPrivacyTerm', {
                                required: true,
                              })}
                              disabled={loadingInputs}
                              onClick={() => {
                                setAcceptedPrivacyTerm(!acceptedPrivacyTerm);
                              }}
                              checked={
                                getValues('acceptedPrivacyTerm') || false
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexCheckPrivacyTerm"
                            >
                              <Markup
                                content={
                                  client?.clientUrl ===
                                  GANHE_MAIS_CORRETOR_CLIENT_URL
                                    ? `Autorizo a Ganhe Mais Corretor a me contatar por e-mail e WhatsApp com informações de interesse da minha atividade profissional. Estou ciente que posso cancelar a qualquer momento pelo link em cada mensagem ou pelo ${client.contactEmail}.`
                                    : 'Autorizo a OQ Mídia Digital Ltda. e OQ Pagamentos Ltda. a me contatar por e-mail e WhatsApp com informações de interesse da minha atividade profissional. Estou ciente que posso cancelar a qualquer momento pelo link em cada mensagem ou pelo dpo@oqdigital.com.'
                                }
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="col-sm-12">
                      <div className="my-3">
                        <Button
                          text={
                            isSubmitting
                              ? !editing
                                ? 'Cadastrando'
                                : 'Atualizando'
                              : !editing
                                ? 'Confirme seus dados'
                                : 'Atualizar dados'
                          }
                          icon="person_add"
                          color="primary"
                          type="submit"
                          isLoading={isSubmitting}
                          disabled={isSubmitting || loadingInputs}
                        />
                      </div>
                      <div className="col-sm-12 col-md-6"></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        {/* fim formulário do perfil */}

        {/* formulário do perfil */}
        {!isLoadingRequestPlayer &&
          client &&
          client.clientUrl === 'bomnegocio' && (
            <div className="row">
              <div className="col-12">
                <div className="container">
                  {/* Perfil e ações do perfil */}
                  {!isLoadingRequestPlayer && (
                    <div className="d-flex flex-column align-items-center">
                      <PlayerAvatar
                        photoURL={photoURL || undefined}
                        size={100}
                      />
                      <div className="d-flex gap-3 my-3">
                        <Button
                          text="Alterar foto"
                          icon="image_search"
                          onClick={handleUploadImage}
                          disabled={loadingInputs}
                          color="primary"
                        />
                        <Button
                          text="Alterar senha"
                          icon="password"
                          disabled={loadingInputs}
                          onClick={toggleModalPassword}
                          color="flat"
                        />
                      </div>
                      <Input
                        hidden
                        type="file"
                        id="uploadImage"
                        {...register('photoURL', {
                          required: false,
                          onChange: (e) => handleSubmitPhoto(e),
                        })}
                        aria-invalid={errors.photoURL ? 'true' : 'false'}
                      />
                    </div>
                  )}
                  {/* fim Perfil e ações do perfil */}

                  <div className="my-4">
                    <div className="d-flex align-items-center justify-content-center">
                      <button
                        className={`rounded-circle btn ${isStep1Complete ? 'bg-success' : 'bg-primary-color'} fs-3 btn-step`}
                      >
                        {isStep1Complete ? (
                          <i className="material-icons">check</i>
                        ) : (
                          '1'
                        )}
                      </button>
                      <div className="divider-step"></div>
                      <button
                        className={`rounded-circle btn 'bg-primary-color' fs-3 btn-step`}
                      >
                        2
                      </button>
                    </div>
                  </div>

                  <form onSubmit={handleForm}>
                    <div className="row mt-5">
                      {!isStep1Complete && (
                        <>
                          <div className="col-12">
                            <h3 className="mb-4">Dados Gerais</h3>
                          </div>

                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="name">Nome</label>
                            <Input
                              type="text"
                              placeholder="Nome"
                              errors={
                                errors.name ? 'Campo de nome obrigatório' : ''
                              }
                              {...register('name', {
                                required: true,
                              })}
                              aria-invalid={errors.name ? 'true' : 'false'}
                            />
                          </div>

                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="email">E-mail de acesso</label>
                            <Input
                              type="text"
                              placeholder="E-mail de acesso"
                              disabled
                              readOnly
                              errors={
                                errors.email ? 'Campo de email obrigatório' : ''
                              }
                              {...register('email', {
                                required: true,
                                pattern: {
                                  value:
                                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: 'invalid email address',
                                },
                              })}
                              aria-invalid={errors.email ? 'true' : 'false'}
                            />
                          </div>

                          {client &&
                            client.clientUrl !== 'credcrea' &&
                            client.isActiveRegisterPhoneNumber &&
                            client.isActiveRegisterPhoneNumber === 'true' && (
                              <div className="col-12 col-sm-12 col-md-6 mb-4">
                                <label htmlFor="phoneNumber">Telefone</label>
                                {client && client.clientUrl !== 'emr' && (
                                  <Input
                                    prefix="+55"
                                    maxLength={15}
                                    type="text"
                                    placeholder="Telefone"
                                    errors={
                                      errors.phoneNumber
                                        ? 'Campo de telefone obrigatório'
                                        : ''
                                    }
                                    {...register('phoneNumber', {
                                      required: true,
                                      onChange: (event) => {
                                        const { value } = event.target;
                                        setValue('phoneNumber', maskTEL(value));
                                        const verifyLengthValue = value.replace(
                                          /\D/g,
                                          ''
                                        );

                                        if (verifyLengthValue.length > 11) {
                                          setFormInvalid(true);
                                          return Notify(
                                            'Formato de telefone incorreto',
                                            'warn'
                                          );
                                        } else {
                                          setFormInvalid(false);
                                        }
                                      },
                                    })}
                                    aria-invalid={
                                      errors.phoneNumber ? 'true' : 'false'
                                    }
                                  />
                                )}
                                {client && client.clientUrl === 'emr' && (
                                  <InputInternational
                                    register={register('phoneNumber', {
                                      required: true,
                                      onChange: (event) => {
                                        const { value } = event.target;
                                        setValue('phoneNumber', value);

                                        // Validar formato do telefone internacional
                                        const phoneRegex = /^\+[1-9]\d{1,13}$/;
                                        const isValidPhone =
                                          phoneRegex.test(value);

                                        if (value && !isValidPhone) {
                                          setFormInvalid(true);
                                          Notify(
                                            'Formato de telefone incorreto',
                                            'warn'
                                          );
                                        } else {
                                          setFormInvalid(false);
                                        }
                                      },
                                    })}
                                    errors={errors}
                                    value={getValues('phoneNumber')}
                                  />
                                )}
                              </div>
                            )}

                          <div className="col-12 col-sm-12 col-md-6 mb-4">
                            <label htmlFor="cpf">
                              {client &&
                              client.clientUrl ===
                                GANHE_MAIS_CORRETOR_CLIENT_URL
                                ? 'CNPJ'
                                : 'CPF ou CNPJ'}
                            </label>
                            <Input
                              type="text"
                              placeholder={
                                client &&
                                client.clientUrl ===
                                  GANHE_MAIS_CORRETOR_CLIENT_URL
                                  ? 'CNPJ'
                                  : 'CPF ou CNPJ'
                              }
                              minLength={11}
                              disabled={isDisabledCpf}
                              errors={
                                errors.cpf
                                  ? client &&
                                    client.clientUrl ===
                                      GANHE_MAIS_CORRETOR_CLIENT_URL
                                    ? 'Campo de cnpj obrigatório'
                                    : 'Campo de cpf ou cnpj obrigatório'
                                  : ''
                              }
                              {...register('cpf', {
                                required: true,
                                onChange: (event) => {
                                  const { value } = event.target;
                                  setValue(
                                    'cpf',
                                    client &&
                                      client.clientUrl ===
                                        GANHE_MAIS_CORRETOR_CLIENT_URL
                                      ? MaskCNPJ(value)
                                      : MaskCPF(value)
                                  );
                                  setFormInvalid(false);
                                },
                              })}
                              aria-invalid={errors.cpf ? 'true' : 'false'}
                            />
                          </div>

                          {isBusinessPlayer && (
                            <div className="col-12 col-sm-12 col-md-6 mb-4">
                              <label htmlFor="cpf">
                                Digite o nome do corretor
                              </label>
                              <Input
                                type="text"
                                value={watch('businessName')}
                                placeholder="Digite o nome do corretor"
                                errors={
                                  errors.businessName
                                    ? 'Campo de cpf ou cnpj obrigatório'
                                    : ''
                                }
                                {...register('businessName')}
                              />
                            </div>
                          )}

                          {client &&
                            client.clientUrl !== 'credcrea' &&
                            client.clientUrl !== 'emccampdemo' &&
                            client.clientUrl !== 'ganhemais' &&
                            client.isActiveRegisterBirthDate &&
                            client.isActiveRegisterBirthDate === 'true' && (
                              <div className="col-12 col-sm-12 col-md-6 mb-4">
                                <label htmlFor="birthDate">
                                  Data de nascimento
                                </label>
                                <Input
                                  type="date"
                                  placeholder="Data de nascimento"
                                  disabled={loadingInputs}
                                  errors={
                                    errors.phoneNumber
                                      ? 'Campo de data de nascimento obrigatório'
                                      : ''
                                  }
                                  {...register('birthDate', {
                                    required: [
                                      'credcrea',
                                      'emccampdemo',
                                      'ganhemais',
                                    ].includes(client.clientUrl)
                                      ? false
                                      : true,
                                  })}
                                  aria-invalid={
                                    errors.phoneNumber ? 'true' : 'false'
                                  }
                                />
                              </div>
                            )}

                          {client &&
                            client.secondarySegmentationChoice &&
                            client.secondarySegmentationChoice === 'true' && (
                              <div className="col-12 col-sm-12 col-md-6 mb-4">
                                <label htmlFor="role">
                                  {client && client.nameSecondarySegmentation}
                                </label>
                                <select
                                  className={`${styles.select}`}
                                  disabled={loadingInputs}
                                  {...register('role', {
                                    required: true,
                                  })}
                                  aria-invalid={errors.role ? 'true' : 'false'}
                                >
                                  <option value={''}>
                                    Selecione uma opção
                                  </option>
                                  {client.secondarySegmentation &&
                                    client.secondarySegmentation.map(
                                      (value: any, index: number) => (
                                        <option key={index} value={value.id}>
                                          {value.text}
                                        </option>
                                      )
                                    )}
                                </select>
                                <span className={styles.error}>
                                  {errors.role
                                    ? `Campo de ${
                                        client &&
                                        client.nameSecondarySegmentation
                                      } obrigatório'`
                                    : ''}
                                </span>
                              </div>
                            )}

                          {client &&
                            client.clientUrl !== 'prideopen' &&
                            client.isActiveRegisterStateAndCity &&
                            client.isActiveRegisterStateAndCity === 'true' && (
                              <div className="col-12 col-sm-12 col-md-6 mb-4">
                                <label htmlFor="state">
                                  Estado de residência
                                </label>
                                <select
                                  className={`${styles.select}`}
                                  disabled={loadingInputs}
                                  {...register('state', {
                                    required: true,
                                    onChange: handleChange,
                                  })}
                                  aria-invalid={errors.state ? 'true' : 'false'}
                                  value={getValues('state')}
                                >
                                  <option value={''}>
                                    Selecione um estado
                                  </option>
                                  {stateList &&
                                    stateList.map((value) => (
                                      <option
                                        key={value.sigla}
                                        value={value.sigla}
                                      >
                                        {value.sigla}
                                      </option>
                                    ))}
                                </select>
                                <span className={styles.error}>
                                  {errors.state
                                    ? 'Campo de estado de residência obrigatório'
                                    : ''}
                                </span>
                              </div>
                            )}

                          {client &&
                            client.clientUrl !== 'prideopen' &&
                            client.isActiveRegisterStateAndCity &&
                            client.isActiveRegisterStateAndCity === 'true' && (
                              <div className="col-12 col-sm-12 col-md-6 mb-4">
                                <label htmlFor="city">
                                  Cidade de residência
                                </label>
                                <select
                                  className={`${styles.select}`}
                                  disabled={loadingInputs}
                                  {...register('city', {
                                    required: true,
                                  })}
                                  aria-invalid={errors.city ? 'true' : 'false'}
                                  value={watch('city')}
                                >
                                  <option value={''}>
                                    Selecione uma cidade
                                  </option>
                                  {cityList &&
                                    cityList.map((value: any) => (
                                      <option
                                        key={value.nome}
                                        value={value.nome}
                                      >
                                        {value.nome}
                                      </option>
                                    ))}
                                </select>
                                <span className={styles.error}>
                                  {errors.city
                                    ? 'Campo de cidade de residência obrigatória'
                                    : ''}
                                </span>
                              </div>
                            )}

                          {client && client.clientUrl === 'bild' && (
                            <div className="col-12 col-sm-12 col-md-6 mb-4">
                              <label htmlFor="correctors">
                                Se você foi indicado por algum(a) corretor(a),
                                selecione quem foi
                              </label>
                              <select
                                className={`${styles.select}`}
                                disabled={loadingInputs}
                                {...register('corretor', {
                                  required: true,
                                })}
                                aria-invalid={
                                  errors.corretor ? 'true' : 'false'
                                }
                              >
                                {correctors &&
                                  correctors.map((value, index) => (
                                    <option
                                      key={index}
                                      value={JSON.stringify(value)}
                                    >
                                      {value.label}
                                    </option>
                                  ))}
                              </select>
                              <span className={styles.error}>
                                {errors.corretor
                                  ? 'Campo de corretor obrigatório'
                                  : ''}
                              </span>
                            </div>
                          )}

                          <div className="col-12">
                            <Button
                              text="próximo passo"
                              color="primary"
                              icon="arrow_forward"
                              onClick={() => {
                                if (getValues('cpf')) {
                                  toast.success(
                                    `Parabéns, +10 ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'} acumulados! Agora é o passo 2...`
                                  );
                                  setIsStep1Complete(true);
                                } else {
                                  toast.error(
                                    'Para prosseguir precisa informar o cpf'
                                  );
                                }
                              }}
                            />
                          </div>
                        </>
                      )}

                      {client && client.clientUrl === 'bomnegocio' && (
                        <>
                          {isStep1Complete && (
                            <>
                              <div className="col-12">
                                <h3 className="mb-4">Dados do condomínio</h3>
                              </div>

                              <div className="col-12 col-sm-12 col-md-6 mb-4">
                                <label htmlFor="name">CEP do condomínio</label>
                                <Input
                                  type="number"
                                  placeholder="CEP do condomínio"
                                  errors={
                                    errors.patrimonyCep
                                      ? 'Campo de CEP do condomínio obrigatório'
                                      : ''
                                  }
                                  {...register('patrimonyCep', {
                                    required: true,
                                  })}
                                  aria-invalid={
                                    errors.patrimonyCep ? 'true' : 'false'
                                  }
                                />
                              </div>

                              <div className="col-12 col-sm-12 col-md-6 mb-4">
                                <label htmlFor="name">
                                  Número do condomínio
                                </label>
                                <Input
                                  type="number"
                                  placeholder="Número do condomínio"
                                  errors={
                                    errors.patrimonyNumber
                                      ? 'Campo de Número do condomínio obrigatório'
                                      : ''
                                  }
                                  {...register('patrimonyNumber', {
                                    required: true,
                                  })}
                                  aria-invalid={
                                    errors.patrimonyNumber ? 'true' : 'false'
                                  }
                                />
                              </div>
                              <div className="col-12">
                                <div className="mb-3">
                                  <List>
                                    <ListItem
                                      content=""
                                      secondaryContent="Por que o CPF/CNPJ?"
                                      expansible={true}
                                      classStyle="border-0 p-0"
                                      contentExpansible={
                                        <>
                                          <div className="col-sm-12">
                                            <div
                                              className="alert alert-success"
                                              role="alert"
                                            >
                                              <p className="fw-semibold">
                                                Por que o CPF/CNPJ?
                                              </p>
                                              <p>
                                                A fim de garantir a segurança e
                                                autenticidade da sua conta,
                                                precisamos solicitar o seu
                                                CPF/CNPJ. Essas informações são
                                                essenciais para validações
                                                exclusivas e verídicas dos
                                                usuários da nossa plataforma.
                                              </p>
                                            </div>
                                          </div>
                                          <div className="col-sm-12">
                                            <div
                                              className="alert alert-warning mb-0"
                                              role="alert"
                                            >
                                              <p className="fw-semibold">
                                                Proteção de dados
                                              </p>
                                              <p>
                                                Nunca, em hipótese alguma,
                                                compartilhamos/vendemos seus
                                                dados com terceiros.
                                              </p>
                                            </div>
                                          </div>
                                        </>
                                      }
                                    />
                                  </List>
                                </div>
                                <div className="col-sm-12">
                                  <div className="d-flex flex-row-reverse me-check">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckDefault"
                                        {...register('acceptedTerms', {
                                          required: true,
                                        })}
                                        disabled={loadingInputs}
                                        onClick={() => {
                                          setAcceptedTerms(!acceptedTerms);
                                        }}
                                        checked={getValues('acceptedTerms')}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="flexCheckDefault"
                                      >
                                        <Markup
                                          content={`De acordo com as Leis 12.965/2014 e 13.709/2018, que regulam o uso da Internet e o tratamento de dados pessoais no Brasil, ao me inscrever autorizo ${
                                            client?.companyName
                                              ? client?.companyName
                                              : 'OQ DIgital'
                                          } a enviar notificações por e-mail ou outros meios e concordo com sua <a class="fw-bold"  target="_blank"
                          href="${client?.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL && playerRegister?.regional === 'sim' ? PRIVACY_POLICY_CORRETOR_URL : PRIVACY_POLICY_LEAD_URL}">Política de Privacidade</a> e <a class="fw-bold" href="/infos">Termos de uso</a>.`}
                                        />
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                {playerRegister &&
                                  playerRegister.regional === 'sim' && (
                                    <div className="col-sm-12">
                                      <div className="d-flex flex-row-reverse me-check">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="flexCheckPrivacyTermPorteiro"
                                            {...register(
                                              'acceptedPrivacyTerm',
                                              {
                                                required: true,
                                              }
                                            )}
                                            disabled={loadingInputs}
                                            onClick={() => {
                                              setAcceptedPrivacyTerm(
                                                !acceptedPrivacyTerm
                                              );
                                            }}
                                            checked={
                                              getValues(
                                                'acceptedPrivacyTerm'
                                              ) || false
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="flexCheckPrivacyTermPorteiro"
                                          >
                                            <Markup
                                              content={
                                                client?.clientUrl ===
                                                GANHE_MAIS_CORRETOR_CLIENT_URL
                                                  ? `Autorizo a ${client.clientUrl} a me contatar por e-mail e WhatsApp com informações de interesse da minha atividade profissional. Estou ciente que posso cancelar a qualquer momento pelo link em cada mensagem ou pelo ${client.contactEmail}.`
                                                  : 'Autorizo a OQ Mídia Digital Ltda. e OQ Pagamentos Ltda. a me contatar por e-mail e WhatsApp com informações de interesse da minha atividade profissional. Estou ciente que posso cancelar a qualquer momento pelo link em cada mensagem ou pelo dpo@oqdigital.com.'
                                              }
                                            />
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                <div className="col-sm-12">
                                  <div className="my-3">
                                    <Button
                                      text={
                                        isSubmitting
                                          ? !editing
                                            ? 'Cadastrando'
                                            : 'Atualizando'
                                          : !editing
                                            ? 'Confirme seus dados'
                                            : 'Atualizar dados'
                                      }
                                      icon="person_add"
                                      color="primary"
                                      type="submit"
                                      isLoading={isSubmitting}
                                      disabled={isSubmitting || loadingInputs}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}

                      <div className="col-sm-12 col-md-6"></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        {/* fim formulário do perfil porteiro */}

        <ModalTerms
          modalTermsIsOpen={modalTermsIsOpen}
          toggleModalTerms={toggleModalTerms}
          clientTerms={clientTerms}
        />
        <ModalChangePassword
          modalPasswordIsOpen={modalPasswordIsOpen}
          toggleModalPassword={toggleModalPassword}
        />
        {client &&
          client.clientUrl !== 'bomnegocio' &&
          (!client.moduleCredits ||
            client.clientUrl !== GANHE_MAIS_CORRETOR_CLIENT_URL) && (
            <ModalConfirmRegister
              modalIsOpen={modalIsOpenConfirmRegister}
              toggleModal={Porteiro}
            />
          )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ModalConfirmRegisterPorteiro
            player={player}
            modalIsOpen={modalIsOpenConfirmRegisterPorteiro}
            toggleModal={toggleModalConfirmRegisterPorteiro}
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ModalFinishRegisterPorteiro
            player={player}
            modalIsOpen={modalIsOpenFinishRegisterPorteiro}
            toggleModal={async () => {
              addPointsToPlayer(30);
              toggleModalFinishRegisterPorteiro();
            }}
          />
        )}
        <ModalConfirmDeletePlayer
          modalIsOpen={modalIsOpenConfirmDeletePlayer}
          toggleModal={toggleModalDeletePlayer}
          confirmeDelete={deleteAccount}
        />
        {client?.moduleCredits === true &&
          client?.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL &&
          editing &&
          playerRegister && (
            <ModalBonusPrimeiroAcesso
              open={modalBonusIsOpen}
              onClose={() => setModalBonusIsOpen(false)}
              playerName={playerRegister.name}
            />
          )}
        <Modal
          open={isOpenModalEmailRecovery}
          onClose={() => {
            setIsOpenModalEmailRecovery(!isOpenModalEmailRecovery);
          }}
          center
        >
          <div className="contents-modal">
            <div className="d-flex justify-content-center">
              <img
                className={styles.alert}
                src="https://cdn-icons-png.flaticon.com/512/6309/6309187.png"
                alt=""
              />
            </div>
            <h1 className="title-modal">Ops! CPF já cadastrado!</h1>
            <p className="subtitle-modal">
              {`Este CPF está vinculado ao email ${emailRecovery}.`}
            </p>
          </div>
          <div className={styles.contentBtn}>
            <Button
              isModal
              text="Recuperar a senha"
              type="button"
              color="primary"
              onClick={() => {
                setIsOpenModalEmailRecovery(!isOpenModalEmailRecovery);
                deleteAccount();
              }}
            />
          </div>
        </Modal>
      </div>
    </>
  );
}
